import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';

import { matchRoutes, useLocation } from 'react-router-dom';

import { PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

import { useClusterQuery } from '@cast/shared-cluster-context-data-access';

type SidebarClusterContextType = ReturnType<typeof useClusterQuery>['cluster'];

const SidebarClusterContext =
  createContext<SidebarClusterContextType>(undefined);

export const SidebarClusterProvider = ({ children }: PropsWithChildren) => {
  const [selectedClusterId, setSelectedClusterId] = useState<
    string | undefined
  >(undefined);
  const isOrganizationReadOnly = useIsOrganizationReadOnly();

  const location = useLocation();

  // match all possible routes with cluster id
  const match = matchRoutes(
    [
      {
        path: `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/*`,
      },
    ],
    location.pathname
  );

  const matchedClusterId = match?.[0]?.params.clusterId;

  useEffect(() => {
    if (isOrganizationReadOnly) {
      setSelectedClusterId(undefined);
      return;
    }

    setSelectedClusterId(matchedClusterId);
  }, [matchedClusterId, isOrganizationReadOnly]);

  const { cluster } = useClusterQuery(selectedClusterId);

  return (
    <SidebarClusterContext.Provider value={cluster}>
      {children}
    </SidebarClusterContext.Provider>
  );
};

export const useSidebarCluster = () => useContext(SidebarClusterContext);
